<template>
  <div data-step="2" data-intro="可自定义新增/删除常用应用，便捷工作~">
    <!-- <div slot="header" class="clearfix">
      <i class="el-icon-setting tools-icon" @click="showOftenFlowManage">编辑</i>
    </div> -->
    <div class="often-flow-container">
      <div v-for="flow in AppList" class="block" :key="flow.id">
        <div @click="click(flow)" class="menu">
          <el-image  :fit="fit" :src="flow.icon"></el-image>
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div slot="content">{{flow.menuname}}</div>
            <span class="menuname">{{flow.label}}</span>
          </el-tooltip>
        </div>
      </div>
      <div class="block">
        <div  class="menu" @click="showOftenFlowManage">
          <el-image  :fit="fit" src="/fvue/img/Group.png"></el-image>
          <span class="menuname">添加/常用应用</span>
        </div>
      </div>
    </div>
    <el-dialog
      title="选择常用应用（最多11个，最少5个）"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="66%"
      id="often-set-dialog"
    >
    <div style="display: flex;">
      <div style="width: 200px;min-width:200px;margin-top: 24px;">
        <el-input placeholder="请输入菜单关键字" v-model="filterText"></el-input>
        <el-tree
          class="filter-tree"
          :data="data"
          :props="defaultProps"
          node-key="id"
          :filter-node-method="filterNode"
          @node-click="handleNodeClick"
          ref="tree">
        </el-tree>
      </div>
      <div style="width: 200px;min-width:200px;margin-top: 24px;">
        <el-input placeholder="请输入应用关键字" v-model="filterText1"></el-input>
        <el-tree
          class="filter-tree"
          show-checkbox
          :data="data1"
          :props="defaultProps1"
          node-key="id"
          :filter-node-method="filterNode"
          @check-change="handleNodeClick1"
          ref="tree">
        </el-tree>
      </div>
      <div>
        <span style="font-size: 14px;font-family: PingFang SC-Semibold, PingFang SC;font-weight: 600;color: #292B44;margin-top: 24px;margin-left: 24px;">
          已选应用（{{AppList.length}}个）
        </span>
        <div class="often-flow-container">
          <div v-for="flow in AppList" style="width:240px;display: inline-block;text-align: center;" :key="flow.id">
            <div class="menu" style="margin-top: 24px;">
              <el-image style="width:68px;" :fit="fit" :src="flow.icon"></el-image>
              <span style="width:130px;" class="menuname">{{flow.label}}</span>
              <div style="width:18px;position: relative;bottom: 20px;" @click="remove(flow)">
                <img src="/fvue/img/remove.png" >
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>

      <!-- <div>
        <h3 class="often-flow-group-title">常用流程</h3>
        <p style="display: inline-block;">点击叉号从常用流程中移除</p>
      </div> -->
      <!-- <div class="often-flow-container" style="background-color: #f5f5f5;">
        <el-tag
          v-for="flow in copyOftenFlows"
          size="medium"
          :key="flow.id"
          closable
          :disable-transitions="false"
          @close="signOftenFlow(flow)"
        >{{flow.name}}</el-tag>
      </div> -->
      <!-- <div>
        <h3 class="often-flow-group-title">更多流程</h3>
        <p style="display: inline-block;">点击加号可以添加至常用流程</p>
        <el-input
          :clearable="true"
          class="often-search-input"
          size="small"
          placeholder="请输入流程名称"
          @keyup.enter.native="searchEnterFun"
          v-model="flowSearchKey"
        >
          <el-button slot="append" icon="el-icon-search" @click="searchFlow"></el-button>
        </el-input>
      </div> -->
      <!-- <div class="flow-list-content" v-if="hasAuthFlowList.length > 0">
        <div v-for="type in hasAuthFlowList" :key="type.name">
          <li v-if="type.icon" :style="type.icon.color" :class="type.icon.icon"></li>
          <h3 style="margin:8px;">{{type.name}}</h3>
          <div class="often-flow-container" style="background-color: #f5f5f5;">
            <el-tooltip
              :content="flow.name"
              :disabled="flow.name.length > 0"
              placement="top"
              :key="flow.id"
              v-for="flow in type.flowList"
            >
              <el-tag v-if="!flow.isAdd" color="#fff" size="medium" @click="signOftenFlow(flow)">
                {{flow.name}}
                <i
                  class="el-icon-circle-plus el-icon--right"
                  style="color:#409eff;"
                  @click="signOftenFlow(flow)"
                ></i>
              </el-tag>
              <p v-if="flow.isAdd">
                <span>{{flow.name}}</span>
                <i class="el-icon-check el-icon--right" style="color:#00d35b"></i>
              </p>
            </el-tooltip>
          </div>
        </div>
      </div> -->
      <!-- <div class="empty-msg-div" v-if="hasAuthFlowList.length == 0 ">
        <p v-if="completeInit">抱歉！没有找到符合条件的流程</p>
        <p v-if="completeInit">您可以尝试更换关键词</p>
      </div> -->

      <span slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button size="small" type="primary" @click="saveOftenFlow">保存</el-button>
        <!-- <el-button size="small" @click="dialogVisible = false">取 消</el-button> -->
      </span>
    </el-dialog>
    <OftenFlowList ref="oftenFlowList"/>
  </div>
</template>
<script>
import { mapState } from "vuex";
import OftenFlowList from "@/components/home/oftenFlowList.vue";
import utils from "@/utils.js";
import req from "@/request.js";
export default {
  components: { OftenFlowList },
  data() {
    return {
      dialogVisible: false,
      flowSearchKey: "",
      fit:"fill",
      filterText: '',
      filterText1: '',
      data: [],
      data1: [],
      AppList:[],
      defaultProps: {
        children: 'children',
          abel: 'label'
      },
      defaultProps1: {
        children: 'children',
          abel: 'label'
      },
    };
  },
  computed: mapState({
    completeInit: state => state.oftenFlow.completeInit,
    oftenFlows: state => state.oftenFlow.oftenFlowList,
    copyOftenFlows: state => state.oftenFlow.copyOftenFlowList,
    hasAuthFlowList: state => state.oftenFlow.hasAuthFlowList
  }),
  watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
      filterText1(val) {
        this.$refs.tree.filter(val);
      }

    },
  created() {
    // this.$store.dispatch("oftenFlow/getMyOftenFlowdw");
  },
  mounted(){
    let this_ = this;
    this_.AppList = [];
    req.post(window.context.portal+"/bpm/haiyaapi/getOftenFlows").then((resp) => {
      if(resp.data!=null){
        for(let i=0;i<resp.data.length;i++){
          this_.AppList.push({id:resp.data[i].yybm,label:resp.data[i].yymc,icon:resp.data[i].icon,type:resp.data[i].type,content:resp.data[i].content
          ,menuname:resp.data[i].menuname});
        }
      }
    });
  },
  methods: {
    remove(flow){
      let this_ = this;
      let new_app = [];
      if(this_.AppList.length>1){
        for(let i=0;i<this_.AppList.length;i++){
          if(this_.AppList[i].id==flow.id){//重组AppList，将当前选中的流程剔除
            this.$message.warning("当前应用：【"+flow.label+"】您已删除。");
          }else{
            new_app.push({id:this_.AppList[i].id,label:this_.AppList[i].label,icon:this_.AppList[i].icon});
          }
        }
        this_.AppList = new_app;
      }else{
        this.$message.warning("常用应用最少需要保留1个。");
      }
    },
        //点击应用
    async click(app) {
      //1常规应用 2数据报表 3自定义视图 4图表 6表单 7模块 8启动流程
      let url = "";
      if (app.type == "4") {
        let content = JSON.parse(app.content);
        url = `/appContent/${app.type}/${content.id}/0`;
      } else if (app.type === '2') {
        let content = JSON.parse(app.content);
        url = `/appContent/${app.type}/${content.key}/0`;
      } else if (app.type === '3') {
        let content = JSON.parse(app.content);
        url = `/appContent/${app.type}/${content.alias}/${content.sqlAlias}`;
      } else if (app.type === '1') {
        url = `/appContent/${app.type}/${app.id}/0`;
      } else if (app.type === '6') {
        let content = JSON.parse(app.content);
        url = `/appContent/${app.type}/${content.id}/0`;
      } else if (app.type === '7') {
        url = `/appContent/${app.type}/${app.id}/0`;
      } else if (app.type === '8') {
        let content = JSON.parse(app.content);
        let resp = {};
        if (content.key) {
          req.get(window.context.portal+"/flow/def/v1/getJson?defKey="+content.key).then(resp => {debugger;
              window.open(`/fvue/agentStart/${resp.data.id}/0`,"_blank","height=" +(screen.availHeight - 50) +",width=" +(screen.availWidth - 10));
          })
        }else {
          req.get(window.context.portal+"/flow/def/v1/getMainById?id="+content.id).then(resp => {debugger;
              window.open(`/fvue/agentStart/${resp.data.id}/0`,"_blank","height=" +(screen.availHeight - 50) +",width=" +(screen.availWidth - 10));
          })
        }
      }else if (app.type==='5') {
        url = app.content;
      }
      if (url)
        window.open(
          url,
          "_blank",
          "height=" +
            (screen.availHeight - 50) +
            ",width=" +
            (screen.availWidth - 10)
        );
    },
    handleNodeClick(data,checked) {
      let this_ = this;
      let param = {menuId: data.id};
      this_.data1 = [];
      req.post(window.context.portal+"/portal/sysApp/v1/authList",param).then(AppResp => {//获取当前选中菜单下的应用列表
      debugger;
        if(AppResp.data!=null){
          for(let i=0;i<AppResp.data.length;i++){
            this_.data1.push({id:AppResp.data[i].id,label:AppResp.data[i].name,type:'app',icon:AppResp.data[i].icon});
          }
        }
      })
    },
    handleNodeClick1(data,checked) {
      let this_ = this;
      let new_app = [];
      let old_app = [];
      if(data.type=='app'){
        if(checked==true){//添加
          if(this_.AppList.length<=10){
            for(let i=0;i<this_.AppList.length;i++){
              if(this_.AppList[i].id==data.id){//重组AppList，将当前选中的流程剔除
                this.$message.warning("当前应用：【"+data.label+"】您已选中。");
                return;
              }
            }
            this_.AppList.push({id:data.id,label:data.label,icon:data.icon});
          }else{
            this.$message.warning("常用应用最多只能设置11个。");
          }
        }else{//删除
          if(this_.AppList.length>1){
            for(let i=0;i<this_.AppList.length;i++){
              if(this_.AppList[i].id!=data.id){//重组AppList，将当前选中的流程剔除
                new_app.push({id:this_.AppList[i].id,label:this_.AppList[i].label,icon:this_.AppList[i].icon});
              }
            }
            this_.AppList = new_app;
          }else{
            this.$message.warning("常用应用最少需要保留1个。");
          }
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //常用流程列表
    oftenFlowDialog() {
      this.$refs.oftenFlowList.oftenFlowListOpen();
    },
    //启动前先检查是否有启动权限
    checkRightsBefore(row){
      //超级管理员账号不做判断
      if(this.$store.state.login.currentUser && this.$store.state.login.currentUser.account != "admin"){
        this.$store.dispatch("oftenFlow/flowHasStartRights",row.defKey).then(resp=>{debugger;
          if(resp.value){
            this.startFlow(row);
          }else{
            this.$message({type:"warning",message:"无启动权限，请联系管理员"});
          }
        });
      }else{
        this.startFlow(row);
      }
    },
    //启动流程
    startFlow(row) {
      let url = window.context.front;
      let token = this.$store.state.login.currentUser.token;
       if (!row.leaders || row.leaders.length==0) {
            //this.$router.push("/agentStart/" + row.id+"/0");
         url = url + "/agentStart/" + row.id+"/0";
         url = url + "?token="+token;
         window.open(url,"_blank","width="+(window.screen.availWidth-10)+",height="+(window.screen.availHeight-70));
             this.dialogVisible = false;
          }else{
            let html='<select ref='+Math.random()+' id="approvalLeaderSelect" style="width: 200px;height: 30px;border-radius: 4px;margin: 20px 70px;" ><option value="">请选择</option>';
              row.leaders.forEach(identity => {
                html+='<option value="'+identity.id+'">'+identity.name+'</option>';
              });
              html+='</select>';
              let this_ =this;
              this.$alert(html, '选择发起人', {
                dangerouslyUseHTMLString: true,
                beforeClose:function(action, instance, done){
                  if(action=='confirm'){
                    let se = document.getElementById('approvalLeaderSelect');
                    if(se.selectedIndex==0){
                      this.$message.warning("请选择一个发起人");
                    }else{
                      instance.close();
                      //this_.$router.push("/agentStart/" + row.id+"/"+se[se.selectedIndex].value);
                      url = url + "/agentStart/" + row.id+"/"+se[se.selectedIndex].value;
                       this.dialogVisible = false;
                      url = url + "?token="+token;
                      window.open(url,"_blank","width="+(window.screen.availWidth-10)+",height="+(window.screen.availHeight-70));
                    }
                  }else{
                    instance.close();
                  }
                }
            });
          }
        
    },
    handleConfirm() {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    async showOftenFlowManage() {//拼接下拉菜单
      let this_ = this;
      req.get(window.context.portal+"/sys/sysMenu/v1/getCurrentUserMenu?menuAlias=appCenterFront").then(async resp => {
        debugger;
        for(let i=0;i<resp.data.value.length;i++){
          let arr = [];
          let arrItem = [];
          for(let j=0;j<resp.data.value[i].children.length;j++){
            arrItem=[];
            for(let k=0;k<resp.data.value[i].children[j].children.length;k++){
              arrItem.push({id:resp.data.value[i].children[j].children[k].id,label:resp.data.value[i].children[j].children[k].name});
            }
            arr.push({id:resp.data.value[i].children[j].id,label:resp.data.value[i].children[j].name,children:arrItem});
          }
          this_.data.push({id:resp.data.value[i].id,label:resp.data.value[i].name,children:arr});
        }
      });
      this_.dialogVisible = true;
      this_.flowSearchKey = "";
      this_.$store.dispatch("oftenFlow/initOftenFlowManageData", { init: true });
    },
    signOftenFlow(tag) {
      if (tag.typeId && this.copyOftenFlows.length >= 11) {
        this.$message.warning("最多可添加11个常用流程");
        return;
      }
      this.$store.dispatch("oftenFlow/signOftenFlow", tag);
    },
    saveOftenFlow() {
      let this_ = this;
      let app = [];
      if(this_.AppList.length<0){
        this.$message.error("您未选择常用应用。");
      }else{
        for(let i=0;i<this_.AppList.length;i++){
          app.push({yymc:this_.AppList[i].label,yybm:this_.AppList[i].id});
        }
        if(this_.AppList.length>11){
          this.$message.error("常用应用最多只能添加（11）个。");
        }else{
          req.post(window.context.portal+"/bpm/haiyaapi/UpdateOftenFlow",{"app":app}).then((resp) => {debugger;
            if(resp.data.state==true || resp.data.state=='true'){
              this.dialogVisible = false;
              utils.reload();
            }else{
              this.$message.error(resp.data.message);
            }
          });
        }
      }
      // if (!this.copyOftenFlows || this.copyOftenFlows.length == 0) {
      //   this.$confirm(
      //     "未添加常用流程，保存后将重置为系统默认常用流程，是否确认保存？"
      //   ).then(_ => {
      //     this.doSave(1);
      //   });
      // } else {
      //   this.doSave();
      // }
    },
    doSave(flag) {
      this.$store
        .dispatch("oftenFlow/saveOftenFlow", this.copyOftenFlows).then(data => {debugger;
          if (data.state) {
            this.dialogVisible = false;
            utils.reload();
          } else {
            this.$message.error(data.message || "保存失败");
          }
        });
    },
    //查询流程
    searchFlow() {
      let queryFilter = {};
      if (this.flowSearchKey) {
        queryFilter = {
          querys: [
            {
              property: "DEF_KEY_",
              value: this.flowSearchKey,
              group: "main",
              operation: "LIKE",
              relation: "OR"
            },
            {
              property: "name_",
              value: this.flowSearchKey,
              group: "main",
              operation: "LIKE",
              relation: "OR"
            }
          ]
        };
      }
      this.$store.dispatch("oftenFlow/initOftenFlowManageData", {
        init: false,
        filter: queryFilter
      });
    },
    //回车查询
    searchEnterFun: function(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.searchFlow();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
/deep/ .menu{
  max-width: 240px !important;
  max-height: 68px !important;
  height: 68px !important;
  width: 90% !important;
  align-items: center;
  display: flex;
  background: #ffffff;
  box-shadow: 0px 4px 10px 2px rgba(10,31,62,0.05);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  margin-left: 24px !important;
}
/deep/ .menu:hover{
  .menuname{
    font-size: 14px !important;
    font-family: PingFang SC-Semibold, PingFang SC !important;
    font-weight: 600 !important;
    color: #1890FF !important;
  }
  box-shadow: 0px 6px 10px 4px rgba(10,34,62,0.12);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
}

/deep/ .menuname{
  overflow:hidden;/*内容超出后隐藏*/
  text-overflow: ellipsis;/* 超出内容显示为省略号 */
  white-space: nowrap;/* 文本不进行换行 */
  padding-right: 16px;
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
}

/deep/ .el-image{
  padding: 16px 16px 16px 16px !important;
  width: 36px !important;
  height: 36px !important;
  margin: 0px !important;
}

.often-flow-container {
  padding: 10px 10px 0px 10px;
}

/deep/.el-card__body {
  height: 100%;
  padding: 0;
}

.often-flow-container /deep/ .el-tag {
  margin: 0 10px 10px 0;
  color: #666;
  cursor: pointer;
  font-weight: bold;
}

.often-flow-container /deep/ .el-tag:hover {
  color: $--theme-color;
}

.type-span {
  color: $--theme-color;
}

#often-set-dialog /deep/ {
  .el-dialog__body {
    padding: 0px 16px 16px 16px;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
  }

  .el-dialog__header {
    padding: 16px;
  }

  .el-dialog__footer {
    padding: 8px 20px;
    text-align: center;
  }
}

.often-flow-group-title {
  margin: 8px 8px 8px 0px;
  color: #333;
  display: inline-block;
}

.flow-list-content {
  max-height: 350px;
  overflow-y: auto;

  li {
    font-size: 16px;
  }

  h3 {
    display: inline-block;
  }

  p {
    margin: 0 10px 10px 0;
    line-height: 28px;
    display: inline-block;

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100px;
    }
  }

  img {
    width: 20px;
    height: 20px;
    border-radius: 10%;
    float: left;
    margin: 2px 5px 0 0;
  }
}

.often-search-input {
  width: 250px;
  float: right;
  top: 10px;
}

.empty-msg-div {
  height: 220px;
  padding-top: 100px;
  text-align: center;

  p {
    margin: 8px;
  }

  p:last-child {
    color: #999;
  }
}
/deep/ .tools-icon {
  float: right;
  padding: 3px 10px;
  color: #999;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
}
/deep/ .block{
  width: 16.5%; 
  display: inline-block;
  text-align: center;
}
/deep/ .el-dialog__title{
  font-size: 14px !important;
  font-family: PingFang SC-Semibold, PingFang SC !important;
  font-weight: 600 !important;
  color: #292B44 !important;
}
</style>
